import React from "react";

function Royxat({ mavzu, activeMavzu, setActiveMavzu }) {
  if (!Array.isArray(mavzu) || mavzu.length === 0) {
    mavzu = ["Mavzular mavjud emas"];
  }
  return (
    <div className="qiymat-quti-mavzu">
      <ol>
        {mavzu.map((qiymat, index) => {
          return (
            <li
              key={index}
              className={activeMavzu === index ? "aktiv-mavzu" : ""}
              onClick={() => setActiveMavzu(index)}
            >
              <span className="mavzu-raqam">{index + 1}.</span>
              <span className="mavzu-nomi">{qiymat.nomi || qiymat}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default Royxat;
